module.exports = __webpack_public_path__ + "8da815fde9007dd3122c57a54068e636.svg";